/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import TEXT from "../../../src/utils/globalText";
import SearchBarWithCTA from "../_utils/CommonSearchComponents/SearchBarWithCTA";
import PrimaryButton from "../_utils/CommonButtons/PrimaryButton";
import { useSelector } from "react-redux";
import CommonCountMultiSelect from "../_utils/NumberCountComponent/CommonCountMultiSelect";
import { IntervalConfiguration } from "../../utils/configurationProvider";
import ICONS from "../../assets/Icons";
import SVGComponent from "../_utils/SVGComponent";

const AdditionalRecipient = ({
  setShowAdditionalSection,
  showAdditionalRecipient,
  handleConfirm,
  recipients,
  setRecipients,
  buttonDisabled,
  setButtonDisabled,
  finalRecipients,
  additionalChip,
  setAdditionalChip,
}) => {
  const [animate, setAnimate] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [buttonActive, setButtonActive] = useState(false);
  const { editBeneficiaryLoading } = useSelector(
    (state) => state.beneCreateAccount,
  );
  const { editInternalLoading } = useSelector((state) => state.internalAcc);
  const [buttonHidden, setButtonHidden] = useState(false);
  const emailRegex = /^[\w.-]+@([\w-]+\.)+[A-Za-z]{2,}$/;

  useEffect(() => {
    if ((editInternalLoading || editBeneficiaryLoading) && !buttonHidden) {
      setButtonHidden(true);
    }
  }, [editBeneficiaryLoading, editInternalLoading]);

  const handleAddRecipient = () => {
    const trimmedEmail = emailInput.trim().toLowerCase();
    if (!trimmedEmail.length) return;

    if (
      trimmedEmail &&
      emailRegex.test(trimmedEmail) &&
      !finalRecipients.includes(trimmedEmail)
    ) {
      setRecipients([...recipients, trimmedEmail]);
      setEmailInput("");
    }
  };

  const removeRecipient = (emailToRemove) => {
    setRecipients((prevRecipients) =>
      prevRecipients.filter((email) => email !== emailToRemove),
    );
    setAdditionalChip((prevAdditional) =>
      prevAdditional.filter((email) => email !== emailToRemove),
    );
    setButtonActive(true);
  };

  useEffect(() => {
    let sa = [...showAdditionalRecipient];
    function arrayEquals(a1, a2) {
      return a1?.sort()?.toString() === a2?.sort()?.toString();
    }
    if (arrayEquals(finalRecipients, sa)) {
      setButtonDisabled(true);
      return;
    }
    setButtonDisabled(!recipients.length && !buttonActive && recipients);
  }, [
    finalRecipients,
    emailInput,
    recipients,
    buttonActive,
    showAdditionalRecipient,
  ]);

  return (
    <>
      {/* Mobile View */}
      <div className="Qmd:hidden min-h-full-height w-full bg-primary-bg">
        <div
          className="fixed w-full top-top-base bg-primary-nav z-z-index-fixed-ui flex items-center "
          onClick={() => setShowAdditionalSection(false)}
        >
          <div className="m-margin-md cursor-pointer">
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              height={"var(--icon-md)"}
              width={"var(--icon-md)"}
              color={"var(--text-primary)"}
            />
          </div>
          <h1 className="text-base text-text-primary">
            {TEXT.ADDITIONAL_RECIPIENTS}
          </h1>
        </div>
        <div className="mt-margin-xl pt-padding-xl mx-margin-sm">
          <SearchBarWithCTA
            btnText={"Add"}
            txtColor={"var(--primary-bg)"}
            placeholder={"Search / Enter recipient's email ID"}
            searchText={emailInput}
            inActiveVariantNeeded={true}
            onInput={(val) => {
              setEmailInput(val);
            }}
            onClick={handleAddRecipient}
            disabledBtnColor={"var(--text-disabled)"}
            disabledTxtColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
            disabledTextColor={"var(--text-primary)"}
            isBtnDisable={
              !emailRegex.test(emailInput) ||
              finalRecipients.includes(emailInput.trim().toLowerCase())
            }
          />
        </div>
        <div className="my-margin-sm mx-margin-md ">
          {recipients.length === 0 && additionalChip.length === 0 && (
            <div className="">
              <p className="text-text-secondary text-xs mt-margin-sm">
                {TEXT.ADD_RECIPIENT_NOTE}
              </p>
              <div className="my-margin-xl flex flex-col items-center gap-gap-sm pt-padding-lg">
                <img
                  className="w-graphic-width-sm h-graphic-square-height-sm mt-margin-xl"
                  src={ICONS?.ASSIGN}
                  alt=""
                />
                <span className="text-text-secondary text-xs">
                  No existing recipients found.
                </span>
              </div>
            </div>
          )}

          {(recipients.length > 0 || additionalChip.length > 0) && (
            <div>
              <div className="text-text-secondary text-font-xs mt-margin-sm">
                <p className="my-margin-md">
                  Click 'confirm' to include them in the list.
                </p>
                <h1>Added recipients</h1>
              </div>

              <div className="mt-margin-sm text-text-primary text-sm flex flex-wrap gap-gap-sm overflow-x-auto max-h-max-height-pop-up">
                {[...recipients, ...additionalChip].map((email, index) => (
                  <div
                    key={index}
                    className={`inline-flex items-center bg-primary-nav-act pl-padding-button-l py-padding-button-m pr-padding-sm rounded-border-radius-md gap-gap-sm max-w-max_width-full relative z-z-index-base global-hover-white ${editInternalLoading || editBeneficiaryLoading ? "opacity-light-opacity cursor-not-allowed pointer-events-none" : ""}`}
                  >
                    <p className="truncate">{email}</p>
                    <img
                      className="w-icon-sm h-icon-sm cursor-pointer"
                      onClick={() => removeRecipient(email)}
                      src={
                        "https://q2pay.in/new_assets/common/dashboard/close_with_white_circle.svg"
                      }
                      alt="Remove"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="absolute h-auto z-z-index-overlay w-full bottom-bottom-base bg-primary-card mt-margin-md ">
          <div className="p-padding-sm gap-gap-sm flex items-center">
            <CommonCountMultiSelect
              bgColor={"bg-primary-bg"}
              textColor={"text-text-primary"}
              count={[...recipients, ...additionalChip].length}
            />
            <h1 className="text-text-primary font-semibold text-sm">
              {[...recipients, ...additionalChip].length < 2
                ? "Recipient added"
                : TEXT.RECIPIENTS_ADDED}
            </h1>
          </div>
          <div className="flex gap-gap-sm p-padding-sm rounded-t-border-radius-md bg-primary-nav">
            <PrimaryButton
              btnText={"Cancel"}
              enabledBgColor={"transparent"}
              hoverOption={"white"}
              outLineColor={"var(--text-primary)"}
              enabledTextColor={"var(--text-primary)"}
              handleFunction={() => {
                if (editInternalLoading || editBeneficiaryLoading) {
                  return;
                }
                setShowAdditionalSection(false);
                setRecipients([]);
              }}
              btnType={"button"}
              fullWidthRequired="true"
              isDisabled={
                (editInternalLoading || editBeneficiaryLoading) === null
                  ? false
                  : editInternalLoading || editBeneficiaryLoading
              }
            />
            <PrimaryButton
              btnType={"submit"}
              btnText={"Confirm"}
              enabledBgColor={"var(--positive-act)"}
              enabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
              hoverOption={"black"}
              fullWidthRequired="true"
              handleFunction={(e) => {
                // setRecipients([]);
                handleConfirm(e);
              }}
              isDisabled={buttonDisabled}
              inActiveVariantNeeded={true}
              isLoaderNeeded={true}
              isLoading={editInternalLoading || editBeneficiaryLoading}
            />
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div
        className={`h-pop-up-height w-small-popup-width rounded-border-radius-md bg-primary-bg hidden Qmd:flex justify-between flex-col m mx-margin-sm animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"} `}
      >
        <div className="flex-1 pt-padding-md">
          <div className="flex mb-margin-sm px-padding-md">
            <div>
              <p className="text-text-primary font-semibold text-font-md">
                {TEXT.ADDITIONAL_RECIPIENTS}
              </p>
              <p className="text-text-secondary text-xs">
                The email IDs provided below will be used to send updates and
                notifications to the selected individuals.
              </p>
            </div>
          </div>
          <div className="px-padding-md">
            <SearchBarWithCTA
              btnText={"Add"}
              txtColor={"var(--primary-bg)"}
              inActiveVariantNeeded={true}
              placeholder={"Search / Enter recipient's email ID"}
              searchText={emailInput}
              onInput={(val) => {
                setEmailInput(val);
              }}
              onClick={handleAddRecipient}
              disabledBtnColor={"var(--text-disabled)"}
              disabledTxtColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
              disabledTextColor={"var(--text-primary)"}
              isBtnDisable={
                !emailRegex.test(emailInput) ||
                finalRecipients.includes(emailInput.trim().toLowerCase())
              }
            />
          </div>

          <div className="">
            {recipients.length === 0 && additionalChip.length === 0 && (
              <div>
                <p className="text-text-secondary text-xs mt-margin-sm pl-padding-md">
                  {TEXT.ADD_RECIPIENT_NOTE}
                </p>
                <div className="my-margin-xl flex flex-col items-center gap-gap-sm pt-padding-lg">
                  <img
                    className="w-graphic-width-sm h-graphic-square-height-sm"
                    src={ICONS?.ASSIGN}
                    alt=""
                  />
                  <span className="text-text-secondary text-xs">
                    No existing recipients found.
                  </span>
                </div>
              </div>
            )}

            {(recipients.length > 0 || additionalChip.length > 0) && (
              <>
                <div className=" text-text-secondary text-font-xs mt-margin-sm px-padding-md">
                  <p className="my-margin-md">
                    Click 'confirm' to include them in the list.
                  </p>
                  <h1>Added recipients</h1>
                </div>
                <div className="mt-margin-sm text-text-primary text-sm flex flex-wrap gap-gap-sm pl-padding-md pr-padding-button-l overflow-y-auto max-h-statistic-graph-height pb-padding-sm">
                  {[...recipients, ...additionalChip].map((email, index) => (
                    <div
                      key={index}
                      className={`inline-flex items-center bg-primary-nav-act pl-padding-button-l py-padding-button-m pr-padding-sm max-w-mobile-width-sm rounded-border-radius-md gap-gap-sm relative z-z-index-base global-hover-white ${editInternalLoading || editBeneficiaryLoading ? "opacity-light-opacity cursor-not-allowed pointer-events-none" : ""}`}
                    >
                      <p className="truncate text-xs">{email}</p>
                      <img
                        className="w-icon-sm h-icon-sm cursor-pointer"
                        onClick={() => removeRecipient(email)}
                        src={
                          "https://q2pay.in/new_assets/common/dashboard/close_with_white_circle.svg"
                        }
                        alt="Remove"
                      />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="relative bottom-top-base w-full ">
          <div className=" flex justify-between gap-gap-sm bg-primary-card p-padding-md items-center rounded-b-border-radius-md">
            <div>
              <div className="gap-gap-sm flex items-center">
                <CommonCountMultiSelect
                  bgColor={"bg-primary-bg"}
                  textColor={"text-text-primary"}
                  count={[...recipients, ...additionalChip].length}
                />

                <h1 className="text-text-primary ">
                  {[...recipients, ...additionalChip].length < 2
                    ? "Recipient added"
                    : TEXT.RECIPIENTS_ADDED}
                </h1>
              </div>
            </div>
            <div className="flex gap-gap-sm">
              <div className="flex mr-margin-sm">
                <div className="flex-grow border-r border-solid border-primary-bg"></div>
              </div>
              {!buttonHidden && (
                <div>
                  <PrimaryButton
                    btnText={"Cancel"}
                    enabledBgColor={"transparent"}
                    hoverOption={"white"}
                    outLineColor={"var(--text-primary)"}
                    enabledTextColor={"var(--text-primary)"}
                    handleFunction={() => {
                      setRecipients([]);
                      setAnimate(true);
                      setTimeout(() => {
                        setShowAdditionalSection(false);
                      }, IntervalConfiguration?.intervalSemiMid);
                    }}
                    btnType={"button"}
                  />
                </div>
              )}
              <PrimaryButton
                btnType={"submit"}
                btnText={"Confirm"}
                enabledBgColor={"var(--positive-act)"}
                enabledTextColor={"var(--text-primary)"}
                disabledBgColor={"var(--text-disabled)"}
                hoverOption={"black"}
                handleFunction={(e) => {
                  // setRecipients([]);
                  handleConfirm(e);
                }}
                isDisabled={buttonDisabled}
                inActiveVariantNeeded={true}
                isLoaderNeeded={true}
                isLoading={editInternalLoading || editBeneficiaryLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalRecipient;
